import React, { useState } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { Form } from '@kuzmycz/react-form-ula';
import { Button, Modal } from '../../../../Components/uielements';
import BioPlusTextField from '../../../../Components/form-fields/BioPlusTextField';
import {
  ModalButtonWrapper,
  ModalGap,
  ModalWrapper,
  OutlineButton,
} from '../../../../services/settings/appStyle/global.style';
import * as GeofenceService from '../../../../services/bioplus-services/geofence';
import DropDown from '../../../../Components/uielements/dropDown';
import { IntlMessages } from '../../../../helper/langHelper';

const OwnerEditGeofenceModal = ({ onClose, data, premisesData }) => {
  const queryClient = useQueryClient();
  const [premise, setPremise] = useState();
  console.log(premisesData, data);
  const mutation = useMutation(GeofenceService.updateGeofence, {
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['geofences'] });
      onClose();
    },
    onError: (error) => {
      alert(`Error: ${error?.response?.data?.message}`);
      onClose();
    },
  });

  const handleSubmit = (values) => {
    let payload = {
      ...values,
      ...(premise && { premiseId: premise.value }),
      ...(premise && { premiseName: premise.label }),
    };
    mutation.mutate(payload);
  };

  const validator = (values) => {
    return undefined;
  };

  const handleSelectedValue = (value) => {
    setPremise(value);
  };

  return (
    <>
      <Modal
        isOpen={true}
        onClose={onClose}
        title={<IntlMessages id="modal.edit.geofence.title" />}
      >
        <Form initialValues={data} validator={validator} onSubmit={handleSubmit}>
          <ModalWrapper>
            <ModalGap>
              <BioPlusTextField
                name="name"
                label={<IntlMessages id="table.col.geofence" />}
                fullWidth
              />
              {/* <BioPlusTextField
                name="contactNumber"
                label={<IntlMessages id="table.col.phone" />}
                fullWidth
              /> */}
              {/* <BioPlusTextField
                name="purpose"
                label={<IntlMessages id="input.label.purpose" />}
                fullWidth
              /> */}
              <DropDown
                options={premisesData}
                selectedOption={handleSelectedValue}
                name="role"
                defaultValue={data?.premiseId?.propertyName}
                label={<IntlMessages id="table.col.premise.name" />}
              />
            </ModalGap>
            <ModalButtonWrapper>
              <OutlineButton onClick={onClose}>
                <IntlMessages id="modal.button.cancel" />
              </OutlineButton>
              <Button varient="normal" type="submit">
                <IntlMessages id="modal.button.submit" />
              </Button>
            </ModalButtonWrapper>
          </ModalWrapper>
        </Form>
      </Modal>
    </>
  );
};

export default OwnerEditGeofenceModal;
